import * as m from 'mithril';
import AppContext from '../context/AppContext';

import { SubFsm } from 'little-fsm';
import { TentativeBookingCreationFsmScheme } from '../states/tentative-booking/TentativeBookingCreationFsmScheme';
import TravellerFormPage from '../pages/travellerinfo/TravellerFormPage';
import { TravellerDTO } from '../apiclient/ApiDtos';
import { ApiService } from '../ApiService';
import { WayPointSelectionFsmContext } from '../states/pickup-dropoff-order/WayPointsSelectionFsmContext';

export function buildTentativeBookingCreationPresenter(
    appContext: AppContext,
    apiService: ApiService,
    subFsm: SubFsm<TentativeBookingCreationFsmScheme>): { render: () => m.Vnode } {

    let messageProvider = appContext.getMessageProvider();

    subFsm.setEnterEffect('creating', c => {
        let travellerInfo = c.travellerInfo;
        let tripCustomizationId = c.tripCustomizationContext.tripCustomization!.id;
        apiService.createTentativeBooking(tripCustomizationId, travellerInfo).then(result => {
            console.log("Tentative Booking result", result);
            //fsm.processEvent('tentative_booking_created', {tentativeBooking: tentativeBooking});
            if (result.right) {
                subFsm.processEvent('created', { tentativeBooking: result.right })
            }
        });
    })

    /* subFsm.setEnterEffect('back_determining', context => {
        if (
            context.tripCustomizationContext instanceof WayPointSelectionFsmContext
            && context.tripCustomizationContext.hasPickUpDropOffOrder()
        ) {
            subFsm.processEvent('back_to_edit_waypoints', {})
        } else if (!context.tripCustomizationContext.tripDetails!!.isSeatSelectionAllowed) {
            subFsm.processEvent("back_to_trip_details", {})
        } else {
            subFsm.processEvent('back_to_search', {});
        }
    }) */

    return {
        render() {
            let context = subFsm.getCurrentContext();
            let substate = subFsm.getCurrentSubState();
            let backTo : 'WAYPOINT_SELECTION' | 'SEAT_SELECTION' | 'SEAT_AUTOASSIGNMENT_INFO'= 'SEAT_SELECTION';
            if (
                context.tripCustomizationContext instanceof WayPointSelectionFsmContext
                && context.tripCustomizationContext.hasPickUpDropOffOrder()
            ) {
                backTo = 'WAYPOINT_SELECTION';                
            }else if(!context.tripCustomizationContext.tripDetails!!.isSeatSelectionAllowed){
                backTo = 'SEAT_AUTOASSIGNMENT_INFO';
            }
            /* else if (!context.tripCustomizationContext.tripDetails!!.isSeatSelectionAllowed) {
                
            } else {
                //subFsm.processEvent('back_to_search', {});
            } */
            return m(TravellerFormPage, {
                appContext: appContext,
                messageProvider: appContext.getMessageProvider(),
                tripCustomization: context.tripCustomizationContext.tripCustomization!,
                isBacktracking: substate == 'back_navigation_confirming',
                backTrackingTo: backTo,
                isSubmitting: substate == 'creating',
                onBacktrack: () => {
                    subFsm.processEvent('back', {});
                },
                onBacktrackConfirmed: () => {
                    subFsm.processEvent('back_confirmed', {});
                },
                onBacktrackCancelled: () => {
                    subFsm.processEvent('back_cancelled', {});
                },
                onSubmit: (travellerInfo: TravellerDTO) => {
                    console.log("Traveller Form submit", travellerInfo);
                    subFsm.processEvent('create_requested', { travellerInfo: travellerInfo });
                },
            });
        }
    }
}